import React from 'react'
import { Image } from 'grommet'
import styled from 'styled-components'
import Adthrive from '../Adthrive'
import { useWindowSize } from '../../hook/useWindowSize'
// import { useIsPremium } from '../../hook/useIsPremium'
import { replaceCDN } from '../../utils'
import { useSelector } from 'react-redux'

const AdthriveBox = styled(Adthrive).attrs(props => ({
  alignSelf: 'stretch',
  justify: 'center',
  pad: { vertical: '.5rem' },
  // margin: { bottom: '1rem' },
  background: 'toolTranslucentBg',
  // round: { size: '2rem', corner: 'bottom' },
}))`
  min-height: 260px;
  & > div {
    margin-bottom: 0px;
  }
  @media (max-width: 550px) {
    min-height: 290px;
  }
`

const MiddleBox = () => {
  // const { isPremium: showBannerBox } = useIsPremium()
  const banners = useSelector(state => state.settings.banners)
  const windowSize = useWindowSize()

  let banner = null
  let bannerSrc = ''
  // if (showBannerBox) {
  if (banners.on) {
    if (banners.bottomDesktop || banners.bottomMobile) {
      if (windowSize.width > 1152) {
        banner = banners.bottomDesktop
      } else {
        //mobile view
        banner = banners.bottomMobile
      }
      bannerSrc = replaceCDN(banner?.src)
    }
  }

  // }

  return (
    <AdthriveBox align={!banner ? 'stretch' : 'center'} id="aboveToolSettings">
      {banner && <Image src={bannerSrc} />}
    </AdthriveBox>
  )
}

export default MiddleBox
